import { useDispatch, useSelector } from 'react-redux';

// RootState and AppDispatch are global types (store/types.d.ts)
// Typed versions of the react-redux hooks, for use in TypeScript files
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
